const url = "/api/routes/get";
var xhttp = new XMLHttpRequest();
xhttp.open("GET", url, false);
xhttp.send()
const laravel = JSON.parse(xhttp.responseText);
const routes = laravel.routes;

module.exports = function () {
    let args = Array.prototype.slice.call(arguments);
    let name = args.shift();
    if (routes[name] === undefined) {
        console.error('Route not found ', name);
    } else {
        return laravel.baseUrl + '/' + routes[name]
            .split('/')
            .map(s => s[0] == '{' ? args.shift() : s)
            .join('/');
    }
};